import { render, staticRenderFns } from "./step-end.vue?vue&type=template&id=08fcd9f6&scoped=true"
import script from "./step-end.vue?vue&type=script&lang=js"
export * from "./step-end.vue?vue&type=script&lang=js"
import style0 from "./step-end.vue?vue&type=style&index=0&id=08fcd9f6&prod&scoped=true&lang=scss"
import style1 from "./step-end.vue?vue&type=style&index=1&id=08fcd9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fcd9f6",
  null
  
)

export default component.exports